export default "__VITE_ASSET__BhxeMF9H__"